import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsyncPipe } from './async.pipe';

@NgModule({
  imports: [CommonModule, AsyncPipe],
  exports: [AsyncPipe],
})
export class IonicHooksModule {}
